<template>
  <v-skeleton-loader v-if="!ready" type="article"></v-skeleton-loader>
  <v-container id="container" v-else fluid class="grey lighten-3">

    <!-- 顶部 -->
    <v-card tile>
      <v-card-title class="pl-1">
        <v-icon color="teal" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>{{reportData.name}}
        <v-spacer />
        <v-btn color="primary" class="ml-2" :disabled="!schema" v-one-click :to="onlineUrl" target="_blank">在线报告</v-btn>
      </v-card-title>
      <v-card-text>{{reportData.note}}</v-card-text>
    </v-card>

    <table width="100%" height="100%" cellspacing="0" class="mt-2">
      <tr>
        <td id="leftBlock" width="300px">
          <v-card tile class="fill-height" :disabled="!schema">
            <v-card-text class="pa-0">
              <v-treeview v-if="moduleList.length" dense :items="moduleList" open-all activatable open-on-click item-key="id" :active.sync="moduleSs" @update:active="onModuleTreeUpdateActive" return-object>
                <template v-slot:label="{item}"><span class="font-weight-black mr-1">{{item._cno}}</span>{{item.name}}</template>
              </v-treeview>
            </v-card-text>
          </v-card>
        </td>

        <td id="spliter" width="5px" class="r-spliter-line"></td>

        <td id="rightBlock" valign="top">
          <module-1 v-if="currentModule._cno==1" v-bind="moduleCptProps" @valueChanged="onModule1ValueChanged"></module-1>
          <module-x v-else v-bind="moduleCptProps"></module-x>
          <!-- <v-card flat class="fill-height grey lighten-3">
            <v-card-text v-if="currentModule" class="fill-height pt-0 pl-1 pr-0">
              <module-1 v-if="currentModule._cno==1" v-bind="moduleCptProps" @valueChanged="onModule1ValueChanged"></module-1>
              <module-x v-else v-bind="moduleCptProps"></module-x>
            </v-card-text>
          </v-card> -->
        </td>
      </tr>
    </table>

  </v-container>
</template>
<script>
/* eslint-disable no-console */
import { getReportModuleList, getReport, getReportModuleDetail, getProjectDetails } from '@/plugins/api';
import activeSpliter from '@/assets/spliter/Spliter.js';
import Module1 from '@/views/Component/ModuleLib/Module1.vue';
import ModuleX from '@/views/Component/ModuleLib/ModuleX.vue';

export default {
  data () {
    return {
      type: null, xmh: null, schema: null, // 文件交互3要素
      id: null, // OA项目id
      reportId: null, // 报告ID
      xmfah: null,
      htbh: null,
      csj: null,
      ypbh: null,

      ready: false,
      reportData: {},
      shareData: null,

      moduleList: [],
      moduleSs: [],
      currentModule: null,
      moduleDetailData: {},

      rightMinHeight: null
    }
  },
  components: { Module1: Module1, ModuleX: ModuleX },
  computed: {
    moduleCptProps () {
      return { reportData: this.reportData, reportId: this.reportId, moduleId: this.currentModule.moduleId, type: this.type, xmh: this.xmh, schema: this.schema, moduleDetailData: this.moduleDetailData, shareData: this.shareData, projectInfo: {id: this.id,xmfah: this.xmfah,htbh: this.htbh,csj: this.csj,ypbh: this.ypbh, type: this.type, xmh: this.xmh,schema: this.schema} }
    },
    onlineUrl () {
      return `/report/view/online?reportId=${this.reportId}&schema=${this.schema}&xmh=${this.xmh}&id=${this.id}&xmfah=${this.xmfah}&htbh=${this.htbh}`
    },
    analyseURL () {
      return `/report/analyse?reportId=${this.reportId}&schema=${this.schema}&xmh=${this.xmh}&id=${this.id}&xmfah=${this.xmfah}&htbh=${this.htbh}&csj=${this.csj}&ypbh=${this.ypbh}`
    }
  },
  created () { this.init() },
  methods: {
    async init () {
      this.reportId = this.$route.query.reportId;
      this.xmh = this.$route.query.xmh;
      this.schema = this.$route.query.schema;
      this.id = this.$route.query.id;
      this.xmfah = this.$route.query.xmfah;
      this.htbh = this.$route.query.htbh;
      this.csj = this.$route.query.csj;
      this.ypbh = this.$route.query.ypbh;
      let paramModuleId = this.$route.query.moduleId;
      //获取项目详细基本信息
      await getProjectDetails(this.xmfah).then(res => this.shareData = res.data.shareData)
      // 获取分析报告基本信息
      await getReport(this.reportId).then(res => this.reportData = res.data);
      this.type = this.reportData.type;
      // 加载交互式分析模块列表
      await getReportModuleList(this.reportId).then(res => {
        let treeData = this.Utility.toTree(res.data, 'id', 'pid');
        this.moduleList = treeData;
      })
      this.initNo();
      if (paramModuleId) {
        let mdl = this.Utility.findById(this.moduleList, paramModuleId, 'moduleId');
        this.moduleSs.push(mdl);
      } else {
        this.moduleSs.push(this.moduleList[0]);
      }
      this.currentModule = this.moduleSs[0];
      await getReportModuleDetail(this.reportId, this.currentModule.moduleId).then(res => this.moduleDetailData = res.data)
      this.ready = true;
      this.$nextTick(() => {
        activeSpliter();
        let mh = document.getElementById('leftBlock').scrollHeight;
        this.rightMinHeight = mh;
        document.getElementById('rightBlock').style.minHeight = mh + 'px';
      });
    },
    initNo () {
      let process = (arr, pNo) => {
        for (let i = 0; i < arr.length; i++) {
          arr[i]._cno = pNo ? (pNo + '.' + (i + 1)) : (i + 1);
          if (arr[i].children && arr[i].children.length) process(arr[i].children, arr[i]._cno);
        }
      }
      process(this.moduleList);
    },
    async onModuleTreeUpdateActive (rows) {
      if (!rows.length) rows.push(this.currentModule);
      if (rows[0].moduleId != this.currentModule.moduleId) {
        let id = rows[0].moduleId;
        await getReportModuleDetail(this.reportId, id).then(res => {
          this.moduleDetailData = res.data;
          this.currentModule = rows[0];
        })
      }
    },
    onModule1ValueChanged (e) {
      this.schema = e;
      this.$router.push(this.analyseURL)
    }
  }
}
</script>